module.exports = __webpack_public_path__ + "img/edu-institution-1.915f5359.png";